export default __webpack_public_path__ + "static/media/3.27856220.jpg";